import React from 'react';
import PropTypes from 'prop-types';

import { useDetailsStyles } from '../styles';

const Details = ({ brand }) => {
  const classes = useDetailsStyles();
  const {
    description,
    expirationDate,
    brandNumber,
    position,
    firstYear,
    dateRegistered,
    county,
    certificatePrinted,
    status,
  } = brand;
  const isRenewable = status === 'RENEWABLE';
  const isExpired = status === 'EXPIRED';

  return (
    <div className={classes.root}>
      <h1>{description}</h1>
      {isRenewable || isExpired ?
        (
          <p className="expires">
            {isExpired ? 'Expired': 'Expires'} {expirationDate}
          </p>
        ) : (
          <p className="active">
            Good Until {expirationDate}
          </p>
        )
      }
      <p>Brand Number: {brandNumber} {position}</p>
      <p>Registered Since: {firstYear}</p>
      <p>County: {county}</p>
      <p>Last Registered: {dateRegistered}</p>
      <p>Certificate Printed: {certificatePrinted}</p>
    </div>
  );
};

Details.propTypes = {
  brand: PropTypes.object.isRequired,
};

export default Details;
